import { PaymentInfoProps, PurchaseOrderStatusCode, statusLabels } from 'types';
import { InventoryDocumentItem, PaymentType } from 'models';
import { formatCurrency } from 'utils';
import {
  ButtonCommon,
  InputCommon,
  ConfirmPaymentModal,
  QuickViewProductsModal,
  QuickViewTransactionsModal,
} from 'components/common';
import { DatePicker, Radio, RadioChangeEvent } from 'antd';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import React from 'react';
import { Bank, Money } from '@phosphor-icons/react';
import dayjs from 'dayjs';
export const StatusTag: React.FC<{ status: PurchaseOrderStatusCode; isDelayed?: boolean }> = ({
  status,
  isDelayed,
}) => {
  if (isDelayed) {
    return (
      <div className='inline-block text-sm px-4 py-1 rounded-full bg-[var(--sematicErrorColor)] text-white'>
        {statusLabels[PurchaseOrderStatusCode.DELAYED]}
      </div>
    );
  }
  let statusColor: string = '';
  if (status === PurchaseOrderStatusCode.READY) statusColor = 'bg-[var(--primaryColor500)] text-white';
  else if (status === PurchaseOrderStatusCode.INPROGRESS) statusColor = 'bg-[var(--primaryColor300)] text-white';
  else if (status === PurchaseOrderStatusCode.RECEIVED) statusColor = 'bg-[var(--tealColor700)] text-white';
  else if (status === PurchaseOrderStatusCode.CANCELLED) statusColor = 'bg-[var(--sematicErrorColor)] text-white';
  else statusColor = 'bg-[var(--textBlack8)] text-[var(--textBlack56)]';
  return (
    <div className={`inline-block  text-sm px-4 py-1 rounded-full ${statusColor} ` + statusColor}>
      {statusLabels[status]}
    </div>
  );
};

export const SectionHeader: React.FC<{ title: string }> = ({ title }) => (
  <h3 className='leading-[24px] text-[20px] font-bold text-[var(--textBlack100)] mb-4'>{title}</h3>
);
export const PaymentInfoCard: React.FC<{ title: string; subtitle?: string }> = ({ title, subtitle }) => (
  <div className='px-[24px] py-[12px] my-6 bg-white rounded-[16px] border-[var(--primaryColor500)] border'>
    <div className='text-sm font-bold'>{title}</div>
    <div className='text-sm text-[var(--textBlack56)]'>{subtitle}</div>
  </div>
);
export const PaymentInfo: React.FC<PaymentInfoProps> = ({
  purchaseOrder,
  title = 'THÔNG TIN THANH TOÁN',
  showPaymentMethods = false,
  showPaymentButton = false,
  showDiscountField = false,
  onPaymentMethodChange,
  onCustomAmountChange,
  onDiscountCodeChange,
  onPaymentSubmit,
  // differentItems = [],
  disableEditing = false,
  recivied = false, // mock for received order, will replace by purchaseOrder.status
  onImport,
  paymentMethod,
  setPaymentMethod = () => {},
  customAmount = '',
  setCustomAmount = () => {},
  datePayment = '',
  setDatePayment = () => {},
  onUpload,
  transactions,
  setTransactionMethod = () => {},
  transactionMethod,
}) => {
  const [discountCode, setDiscountCode] = useState<string>('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isQuickViewTransactionOpen, setIsQuickViewTransactionOpen] = useState(false);
  const [isViewProductModalOpen, setIsViewProductModalOpen] = useState(false);
  const location = useLocation();
  const selectedItems = location.state?.selectedItems as InventoryDocumentItem[] | undefined;
  const navigate = useNavigate();
  useEffect(() => {
    if (purchaseOrder?.paymentType) {
      setPaymentMethod(purchaseOrder.paymentType);
    }
  }, [purchaseOrder]);
  // Calculate amounts
  const remainingAmount = purchaseOrder?.unpaidMoney || 0;

  // Get quantity of items
  const itemCount = selectedItems ? selectedItems.length || 0 : purchaseOrder.inventoryDocumentItems?.length || 0;
  const rawTotal = selectedItems
    ? selectedItems.reduce((sum, item) => sum + (item.costPrice || 0) * (item.quantity || 0), 0)
    : purchaseOrder.inventoryDocumentItems?.reduce(
        (sum, item) => sum + (item.costPrice || 0) * (item.actualQuantity || item.quantity || 0),
        0,
      ) || 0;
  const handlePaymentMethodChange = (e: RadioChangeEvent) => {
    const method = e.target.value as PaymentType;
    setPaymentMethod(method);
    onPaymentMethodChange?.(method);
  };

  const handleCustomAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCustomAmount(value);
    const numValue = parseFloat(value);
    if (!isNaN(numValue)) {
      onCustomAmountChange?.(numValue);
    }
  };

  const handleDiscountCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setDiscountCode(value);
    onDiscountCodeChange?.(value);
  };

  const handlePaymentSubmit = () => {
    onPaymentSubmit?.();
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    setIsModalOpen(false);
  };
  showPaymentMethods =
    showPaymentMethods && !(Number(purchaseOrder?.total || 0) - Number(purchaseOrder?.payInAdvance || 0) <= 0);
  showDiscountField = false; // disable discount field
  return (
    <div className='p-4 rounded-[16px] flex flex-col justify-between h-full'>
      <div>
        <SectionHeader title={title} />

        {/* Payment Methods */}
        {showPaymentMethods && (
          <div className='mb-6'>
            <ConfirmPaymentModal
              isOpen={isModalOpen}
              onClose={hideModal}
              onBack={handleBack}
              onContinue={handlePaymentSubmit}
              onUpload={onUpload}
              fileName='ORDER123.xls'
              supplierContact={{
                phone: purchaseOrder.supplier?.baseUser.phoneNumber || '---',
                email: purchaseOrder.supplier?.baseUser.email || '---',
              }}
            />
            <Radio.Group
              onChange={handlePaymentMethodChange}
              value={paymentMethod}
              disabled={disableEditing}
              className='w-full flex flex-col gap-3 custom-radio radio-border-primary mt-4 custom-group-radio'
            >
              <Radio
                value={PaymentType.FULL_PAYMENT}
                className='w-full rounded-xl p-4 !border-[var(--textBlack12)] border'
              >
                <div>
                  <div className='font-medium title-bold'>Thanh toán toàn bộ</div>
                  <div className='text-sm text-[var(--textBlack56)]'>Thanh toán tổng số tiền của tất cả sản phẩm</div>
                </div>
              </Radio>
              <Radio
                value={PaymentType.PARTIAL_PAYMENT_FLEX}
                className='w-full  !border-[var(--textBlack12)] border rounded-xl p-4'
              >
                <div>
                  <div className='font-medium title-bold'>Thanh toán số tiền tùy chọn</div>
                  <div className='text-sm text-[var(--textBlack56)]'>Thanh toán với NCC số tiền tùy chọn</div>
                </div>
              </Radio>

              {/* <Radio
                value={PaymentType.NEGOTIATED_PAYMENT}
                className='w-full  !border-[var(--textBlack12)] border rounded-xl p-4'
              >
                <div>
                  <div className='font-medium title-bold'>Thanh toán sau</div>
                  <div className='text-sm text-[var(--textBlack56)]'>2 bên bàn bạc thanh toán</div>
                </div>
              </Radio> */}
            </Radio.Group>
          </div>
        )}

        {!showPaymentMethods &&
          // !recivied &&
          (purchaseOrder.paymentType === PaymentType.NEGOTIATED_PAYMENT ? (
            <PaymentInfoCard title='Thanh toán sau' subtitle='2 bên bàn bạc thanh toán' />
          ) : purchaseOrder.paymentType === PaymentType.PARTIAL_PAYMENT_FLEX ? (
            <PaymentInfoCard title='Thanh toán số tiền tùy chọn' subtitle='Thanh toán với NCC số tiền tùy chon' />
          ) : purchaseOrder.paymentType === PaymentType.PARTIAL_PAYMENT_FIXED ? (
            <div className='my-4'></div>
          ) : (
            // <PaymentInfoCard
            //   title='Thanh toán tối thiểu'
            //   subtitle='Bạn đã thanh toán một phần số tiền của đơn hàng này'
            // />
            <PaymentInfoCard title='Thanh toán toàn bộ' subtitle='Thanh toán tổng số tiền của tất cả sản phẩm' />
          ))}
        {recivied && <div className='my-4' />}
        {/* Order Summary */}

        <div className='grid grid-cols-1 grid-cols-4 gap-4 gap-y-2 items-center'>
          <div className='text-sm text-[var(--textBlack100)]'>Số lượng</div>
          <div className='text-sm font-medium flex items-center gap-2 col-span-3'>
            <span className='flex gap-2 text-[var(--textBlack56)]'>
              <span className='font-medium text-[var(--textBlack100)]'>{itemCount}</span> sản phẩm
            </span>
            <span
              onClick={() => setIsViewProductModalOpen(true)}
              className='text-[var(--primaryColor500)] font-bold cursor-pointer'
            >
              Nhấn để xem nhanh
            </span>
          </div>

          <span className='text-sm text-[var(--textBlack100)]'>Tạm tính</span>
          <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
            {formatCurrency(rawTotal)} <span className='text-[var(--textBlack56)]'>VND</span>
          </span>

          <hr className='my-2 col-span-4' />

          {purchaseOrder.paymentType !== PaymentType.PARTIAL_PAYMENT_FIXED && (
            <>
              <span className='text-sm text-[var(--textBlack100)]'>VAT</span>
              <span className='col-span-3 font-medium text-[var(--textBlack100)]  flex items-center'>
                {purchaseOrder.vat || 0}% <span className='text-[var(--textBlack56)] mx-2'>~</span>{' '}
                {formatCurrency(rawTotal * ((purchaseOrder.vat || 0) / 100))}
                <span className='ml-2 text-[var(--textBlack56)]'> VND</span>
              </span>

              <span className='text-sm text-[var(--textBlack100)]'>Mã giảm giá</span>
              {showDiscountField ? (
                <div className='col-span-3'>
                  <InputCommon
                    hardSize='md'
                    radius='lg'
                    placeholder='Nhập vào mã giảm giá'
                    value={discountCode}
                    onChange={handleDiscountCodeChange}
                    disabled={disableEditing}
                  />
                </div>
              ) : (
                <span className='col-span-3 font-medium text-[var(--textBlack100)]'>
                  <span className='text-[var(--textBlack56)]'>---</span>
                </span>
              )}
              <hr className='my-2 col-span-4' />
            </>
          )}

          {showPaymentMethods && (
            <>
              <span className='text-sm text-[var(--textBlack100)] font-bold'>
                {recivied ? 'Đã thanh toán' : 'Tổng tiền '}
              </span>
              <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
                {formatCurrency(purchaseOrder.total)} <span className='text-[var(--textBlack56)]'>VND</span>
              </span>
              <span className='text-sm text-[var(--textBlack100)] font-bold'>Trả trước</span>
              <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
                {formatCurrency(purchaseOrder?.payInAdvance || 0)}{' '}
                <span className='text-[var(--textBlack56)]'>VND</span>
              </span>

              <span className='text-sm text-[var(--textBlack56)]'>Còn lại</span>
              <span className='col-span-3 font-bold text-text-[var(--textBlack100)]'>
                {formatCurrency(purchaseOrder?.total - (purchaseOrder?.payInAdvance || 0))}{' '}
                <span className='text-[var(--textBlack56)]'>VND</span>
              </span>
              {/* when have different items */}
              {/* {differentItems.length > 0 && (
                <>
                 
                  <span className='text-sm text-[var(--textBlack56)]'>Chênh lệch</span>
                  <span className='col-span-3 font-bold text-[var(--sematicErrorColor500)]'>
                    {formatCurrency(-123333)} {''}
                    <span className='opacity-60'>VND</span>
                  </span>
                  <span className='text-sm text-[var(--textBlack56)]'>Tổng còn lại</span>
                  <span className='col-span-3 font-bold text-[var(--sematicErrorColor500)]'>
                    {formatCurrency(87000000)} {''}
                    <span className='opacity-60'>VND</span>
                  </span>
                </>
              )} */}
              {paymentMethod === PaymentType.PARTIAL_PAYMENT_FLEX && showPaymentMethods && (
                <>
                  <span className='text-sm text-[var(--textBlack100)] font-bold'>Trả thêm</span>
                  <span className='col-span-3 text-[var(--textBlack100)]'>
                    <InputCommon
                      hardSize='sm'
                      radius='lg'
                      type='money'
                      max={purchaseOrder?.total - (purchaseOrder?.payInAdvance || 0) || 0}
                      placeholder='Nhập số tiền muốn thanh toán'
                      value={customAmount}
                      onChange={handleCustomAmountChange}
                      className='w-full'
                    />
                  </span>
                  <span className='text-sm text-[var(--textBlack100)] font-bold'>Ngày thanh toán</span>
                  <span className='col-span-3 text-[var(--textBlack100)]'>
                    <DatePicker
                      className='w-full !h-8'
                      placeholder='Chọn ngày thanh toán còn lại'
                      value={datePayment ? dayjs(datePayment) : null}
                      onChange={setDatePayment}
                      format='DD/MM/YYYY'
                      disabledDate={(current) => current && current < dayjs().startOf('day')}
                    />
                  </span>
                </>
              )}
            </>
          )}
          {recivied && (
            <>
              <span className='text-sm text-[var(--textBlack100)] font-bold'>
                {/* when integrate with backend */}
                {/* {purchaseOrder?.status?.code !== 'PO_RECEIVED' ? 'Tổng tiền' : 'Đã thanh toán'} */}
                {'Tổng tiền '}
              </span>
              <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
                {formatCurrency(purchaseOrder.total)} <span className='text-[var(--textBlack56)]'>VND</span>
              </span>
              {purchaseOrder.paymentType !== PaymentType.PARTIAL_PAYMENT_FIXED && (
                <>
                  <span className='text-sm text-[var(--textBlack100)] font-bold'>Đã thanh toán</span>
                  <span className='col-span-3 font-bold text-[var(--primaryColor500)]'>
                    {formatCurrency(purchaseOrder?.payInAdvance || 0)} <span className='opacity-60'>VND</span>
                  </span>

                  <span className='text-sm text-[var(--textBlack56)]'>Còn lại</span>
                  <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
                    {formatCurrency(purchaseOrder?.total - (purchaseOrder?.payInAdvance || 0))}{' '}
                    <span className='text-[var(--textBlack56)]'>VND</span>
                  </span>
                </>
              )}
              {purchaseOrder?.paymentType !== PaymentType.FULL_PAYMENT &&
                purchaseOrder.paymentType !== PaymentType.PARTIAL_PAYMENT_FIXED && (
                  <span className='text-sm col-span-4 text-[var(--sematicErrorColor500)]'>
                    Số tiền còn lại được chuyển về công nợ{' '}
                    <span
                      className='font-bold cursor-pointer '
                      onClick={() => navigate(`/management/debts?type=SUPPLIER&id=${purchaseOrder?.Debt?.[0]?.id}`)}
                    >
                      {purchaseOrder?.Debt?.[0]?.code}
                    </span>
                  </span>
                )}
            </>
          )}
          {!showPaymentMethods && !recivied && (
            <>
              <span className='text-sm text-[var(--textBlack100)] font-bold'>{'Tổng tiền '}</span>
              <span className='col-span-3 font-bold text-[var(--textBlack100)]'>
                {formatCurrency(purchaseOrder.total)} <span className='text-[var(--textBlack56)]'>VND</span>
              </span>
              <div className='col-span-4 flex items-center gap-2'>
                <div className='text-sm text-[var(--textBlack56)] font-normal'>
                  {recivied
                    ? 'Đã thanh toán đủ số tiền cho NCC'
                    : 'Số tiền này được thanh toán khi nhận hàng hoặc theo bàn bạc của 2 bên'}
                </div>
              </div>
            </>
          )}
          {recivied && purchaseOrder.paymentType !== PaymentType.PARTIAL_PAYMENT_FIXED && (
            <div className='col-span-4 flex items-center gap-2'>
              <div
                className='text-sm text-[var(--primaryColor500)] font-bold cursor-pointer'
                onClick={() => setIsQuickViewTransactionOpen(true)}
              >
                Lịch sử thanh toán đơn hàng
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Payment Button */}
      {showPaymentButton && (
        <>
          {showPaymentMethods ? (
            <div className='mt-4'>
              <div className='flex gap-3 mb-2'>
                <ButtonCommon
                  color={transactionMethod === 'CASH' ? 'primary' : 'soft'}
                  radius='rounded'
                  className='!w-[50%] h-10'
                  onClick={() => setTransactionMethod('CASH')}
                  icon={<Money size={20} />}
                >
                  Tiền mặt
                </ButtonCommon>

                <ButtonCommon
                  color={transactionMethod === 'BANK_TRANSFER' ? 'primary' : 'soft'}
                  radius='rounded'
                  className='!w-[50%] h-10'
                  onClick={() => setTransactionMethod('BANK_TRANSFER')}
                  icon={<Bank size={20} />}
                >
                  Chuyển khoản
                </ButtonCommon>
              </div>
              <ButtonCommon
                color={paymentMethod === PaymentType.PARTIAL_PAYMENT_FLEX ? 'danger' : 'primary'}
                fullWidth
                onClick={
                  () => setIsModalOpen(true)
                  // paymentMethod !== PaymentType.FULL_PAYMENT
                  //   ? () => {
                  //       if (
                  //         Number(customAmount) < 0 ||
                  //         Number(customAmount) < purchaseOrder?.total - (purchaseOrder?.payInAdvance || 0)
                  //       ) {
                  //         showAlertNotification({
                  //           type: 'warning',
                  //           title: 'Vui lòng chọn ngày thanh toán',
                  //           message: 'Vui lòng chọn ngày thanh toán cho số tiền còn lại',
                  //         });
                  //       } else {
                  //         setIsModalOpen(true);
                  //       }
                  //     }
                  //   : () => {
                  //       setIsModalOpen(true);
                  //     }
                }
                className='rounded-[12px]'
              >
                <span className='flex flex-row w-full justify-between items-center gap-2 font-bold'>
                  <span>
                    {paymentMethod === PaymentType.PARTIAL_PAYMENT_FLEX ? 'Thanh toán & Tạo công nợ' : 'Thanh toán'}
                  </span>
                  <span>
                    {formatCurrency(
                      paymentMethod === PaymentType.FULL_PAYMENT || paymentMethod === PaymentType.NEGOTIATED_PAYMENT
                        ? purchaseOrder.total - (purchaseOrder?.payInAdvance || 0)
                        : paymentMethod === PaymentType.PARTIAL_PAYMENT_FIXED
                          ? remainingAmount
                          : paymentMethod === PaymentType.PARTIAL_PAYMENT_FLEX && !isNaN(parseFloat(customAmount))
                            ? parseFloat(customAmount)
                            : 0,
                    )}{' '}
                    <span className='ml-2 font-normal'>VND </span>
                  </span>
                </span>
              </ButtonCommon>
            </div>
          ) : (
            <ButtonCommon color={'primary'} fullWidth onClick={onImport} className='rounded-[12px] font-bold'>
              Nhập hàng
            </ButtonCommon>
          )}
        </>
      )}
      <QuickViewProductsModal
        isOpen={isViewProductModalOpen}
        onClose={() => setIsViewProductModalOpen(false)}
        products={selectedItems ? selectedItems : purchaseOrder.inventoryDocumentItems || []}
      />
      <QuickViewTransactionsModal
        isOpen={isQuickViewTransactionOpen}
        onClose={() => setIsQuickViewTransactionOpen(false)}
        transactions={transactions || []}
        title='LỊCH SỬ THANH TOÁN'
      />
    </div>
  );
};
